// extracted by mini-css-extract-plugin
export var typingIndicator = "_mw-0";